import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function useMeta() {
  const [meta, setMeta] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/meta").then(({ data }) => { cache = data; setMeta(data); }).catch(() => {});
  }, []);
  return meta || { pipeline_stages: [], lost_outcomes: [], activity_types: [], lead_sources: [], lead_types: [], roles: [], commission_statuses: [] };
}
